import { render, staticRenderFns } from "./ConfirmPayment.vue?vue&type=template&id=90188558&scoped=true"
import script from "./ConfirmPayment.vue?vue&type=script&lang=js"
export * from "./ConfirmPayment.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPayment.vue?vue&type=style&index=0&id=90188558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90188558",
  null
  
)

export default component.exports